module.exports = __webpack_public_path__ + "img/lifestyle_circle_frame_03.1fe883a0.png";